<template>
  <section class="app-main" :class="{hasHead: $route.meta.titleBar}">
    <transition :name="transitionName">
      <keep-alive :include="cachedViews">
        <router-view :key="key"/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  data () {
    return {
      transitionName: ''
    }
  },
  computed: {
    cachedViews() {
      return ['bindingMobile', 'userInfo']
    },
    key() {
      return this.$route.fullPath
    }
  },
  watch: {
    $route (to, from) {
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  },
  methods: {},
  mounted () {},
  created () {},
  components: {}
}
</script>

<style scoped lang='less'>
.app-main{
  background: #f6f6f6;
}
</style>
